export const DEFAULT_ERROR = 'Ошибка. Попробуйте позже';
export const PHONE_NUMBER_VALIDATION_ERROR = 'Телефон должен состоять из 10 цифр (без +7) и не начинаться с 0';
export const KEY_PHONE_NUMBER_FIELD_VALIDATION_ERROR = 'phoneNumber';
export const KEY_PHONE_NUMBER_FIELD_VALIDATION_ERROR_NOT_AUTH = 'contactPhoneNumber';